export default {"src":"/blog/_next/static/media/facebook.963058f2.svg","height":15,"width":8};